/**
 * @generated SignedSource<<b861bee17c4c5d70b7ebcc2d82738916>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
  readonly " $fragmentType": "BuyerProductCarousel_user";
};
export type BuyerProductCarousel_user$key = {
  readonly " $data"?: BuyerProductCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showMerchandizingTool"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductCarousel_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showMerchandizingTool",
          "variableName": "showMerchandizingTool"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "983c36fd7e00f0c0921d7d303d3aae6d";

export default node;
